// WALQO set PDP color preview remap v5 — scoped to Everyday Leash & Harness Set only.
(() => {
  if (!window.location.pathname.includes('/products/everyday-leash-harness-set')) return;

  const mediaMap = {
    harness: {
      black: '2.jpg',
      'deep-blue': 'ChatGPTImage2026_5_5_20_39_38_4.png',
      brown: 'ChatGPTImage2026_5_5_20_39_37_3.png',
      pink: 'ChatGPTImage2026_5_5_20_39_36_1.png',
      purple: 'ChatGPTImage2026_5_5_20_39_37_2.png'
    },
    leash: {
      black: 'ChatGPT_Image_2026_5_13_00_45_23_1.png',
      'deep-blue': 'ChatGPT_Image_2026_5_13_00_45_24_2.png',
      brown: 'ChatGPT_Image_2026_5_13_00_45_24_3.png',
      pink: 'ChatGPT_Image_2026_5_13_00_45_25_4.png',
      purple: 'ChatGPT_Image_2026_5_13_00_45_26_5.png'
    }
  };

  const normalizeColor = (value) => {
    const text = String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    if (text.includes('deep') && text.includes('blue')) return 'deep-blue';
    if (text.includes('brown')) return 'brown';
    if (text.includes('pink')) return 'pink';
    if (text.includes('purple')) return 'purple';
    if (text.includes('black')) return 'black';
    return text;
  };

  const findMediaUrl = (filename, width = 720) => {
    const candidates = [
      ...document.querySelectorAll('[data-walqo-media-thumb]'),
      ...document.querySelectorAll('.walqo-pdp-essential-hero img')
    ];
    const match = candidates.find((node) => {
      const values = [node.dataset?.mainSrc, node.dataset?.mainSrcset, node.currentSrc, node.src, node.srcset]
        .filter(Boolean)
        .join(' ');
      return values.includes(filename);
    });
    const source = match?.dataset?.mainSrc || match?.currentSrc || match?.src || '';
    if (source) return source.replace(/([?&])width=\d+/, `$1width=${width}`);
    return `/cdn/shop/files/${filename}?width=${width}`;
  };

  const buildSrcset = (filename) => [180, 260, 360, 540, 720]
    .map((width) => `${findMediaUrl(filename, width)} ${width}w`)
    .join(', ');

  const setPreview = (item, colorValue) => {
    const filename = mediaMap[item]?.[normalizeColor(colorValue)];
    const image = document.querySelector(`[data-bundle-preview-image="${item}"]`);
    if (!filename || !image) return;
    image.src = findMediaUrl(filename, 720);
    image.srcset = buildSrcset(filename);
  };

  const syncActive = () => {
    document.querySelectorAll('[data-walqo-color-option].is-active').forEach((button) => {
      setPreview(button.dataset.bundleItem, button.dataset.optionValue);
    });
  };

  const bind = () => {
    syncActive();
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-walqo-color-option]');
      if (!button) return;
      window.setTimeout(() => setPreview(button.dataset.bundleItem, button.dataset.optionValue), 0);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})();
